import type { ReactNode } from "react";
import { appMarkUrl } from "../lib/branding";

export function AppMark({
  className,
  children,
  tint,
}: {
  className: string;
  children: ReactNode;
  tint?: string | null;
}) {
  if (appMarkUrl && tint)
    return (
      <span className={`${className} relative isolate inline-block shrink-0`} aria-hidden="true">
        <img src={appMarkUrl} alt="" className="size-full object-contain" />
        <span
          className="absolute inset-0"
          style={{
            backgroundColor: tint,
            mixBlendMode: "color",
            maskImage: `url(${JSON.stringify(appMarkUrl)})`,
            maskSize: "contain",
            maskPosition: "center",
            maskRepeat: "no-repeat",
          }}
        />
      </span>
    );
  return appMarkUrl ? (
    <img src={appMarkUrl} alt="" className={`${className} shrink-0 object-contain`} />
  ) : (
    children
  );
}
